module.exports = __webpack_public_path__ + "static/media/lunchclub-appstore-qr.6e80f36b.svg";